import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY } from './report-parameter-names';

const messages = defineMessages({
  allTransactions: {
    defaultMessage: 'All',
    id: 'XnFzT4',
    description: 'Insights > Reports > Account Balance History > All',
  },
  purchaseTransactions: {
    defaultMessage: 'Purchase',
    id: '/uLaUA',
    description: 'Insights > Reports > Account Balance History > Purchase',
  },
  refundTransactions: {
    defaultMessage: 'Refund',
    id: 'ElGs+R',
    description: 'Insights > Reports > Account Balance History > Refund',
  },
  creditTransactions: {
    defaultMessage: 'Credit',
    id: 'RNWkfG',
    description: 'Insights > Reports > Account Balance History > Credit',
  },
  adjustmentTransactions: {
    defaultMessage: 'Adjustment',
    id: 'TtuS3S',
    description: 'Insights > Reports > Account Balance History > Adjustment',
  },
  printTransactions: {
    defaultMessage: 'Print',
    id: 'iAnbTY',
    description: 'Insights > Reports > Account Balance History > Print',
  },
});

export default [
  {
    name: <FormattedMessage {...messages.allTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'All',
  },
  {
    name: <FormattedMessage {...messages.purchaseTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'Purchase',
  },
  {
    name: <FormattedMessage {...messages.refundTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'Refund',
  },
  {
    name: <FormattedMessage {...messages.creditTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'Credit',
  },
  {
    name: <FormattedMessage {...messages.adjustmentTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'Adjustment',
  },
  {
    name: <FormattedMessage {...messages.printTransactions} />,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: 'Print',
  },
];
